import Button from "components/ui/button/Button";
import Tooltip from "components/ui/tooltip/Tooltip";
import { BulkSaveEntity } from "./bulkSaveEntityConfig";
import { BulkSaveLeadDrawer } from "./BulkSaveLeadDrawer";
import { useBulkSaveLead } from "./useBulkSaveLead";

type Props = {
  /** The selection to save — may mix bulk-savable types (e.g. `contact` + `contact_cognism`). */
  entities: BulkSaveEntity[];
};

export function BulkSaveLeadButton({ entities }: Props) {
  const {
    isDrawerOpen,
    setIsDrawerOpen,
    isInitialLoading,
    savedLeadIds,
    defaultValues,
    tooltipContent,
    handleClick,
  } = useBulkSaveLead(entities);

  return (
    <>
      <Tooltip content={tooltipContent}>
        <Button loading={isInitialLoading} onClick={handleClick} icon="bookmark">
          Save to lead
        </Button>
      </Tooltip>
      <BulkSaveLeadDrawer
        isOpen={isDrawerOpen}
        onOpenChange={setIsDrawerOpen}
        savedLeadIds={savedLeadIds}
        entities={entities}
        defaultValues={defaultValues}
        trackingData={{ "Context source": "Bulk action" }}
      />
    </>
  );
}
